const getters = {
  token: state => state.user.token,
  userId: state => state.user.adminId,
  userName: state => state.user.name,
  token: state => state.user.token,
  avatar: state => (state.user.avatar || state.user.icon),
  name: state => state.user.name,
  adminName: state => state.user.adminName,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  routes: state => state.permission.routes,
  departmentName: state => state.user.departmentName,
  icon: state => state.user.icon,
  permissions: state => state.user.permissions,
  unreadMessageCount: state => state.user.unreadMessageCount, // 未读消息数量
  provider: state => state.user.provider, // 全局provider信息
  // sidebar: state => state.app.sidebar,
  // size: state => state.app.size,
  // device: state => state.app.device,
  // visitedViews: state => state.tagsView.visitedViews,
  // cachedViews: state => state.tagsView.cachedViews,
  // errorLogs: state => state.errorLog.logs,
}
export default getters
